import type { DispensaryFeatureProps } from '../components/map/types'

/** Legacy block records do not describe a current customer-facing feature.
 * Keep actual tracking and ownership, without mutating the stored records.
 */
export function trackingOnlyProperties(props: DispensaryFeatureProps): DispensaryFeatureProps {
  return { ...props,
    track_state: props.track_state === 'both' ? 'tracking'
      : props.track_state === 'blocked' ? 'untracked' : props.track_state,
    blocked_by_competitor: false,
  }
}

/** Retired actions cannot be invoked through stale map handles or dialogs. */
export function isTrackingAction(action: string): boolean {
  return action === 'track'
}
